export default {
    dictList: {},
    tableData: {},
    statData: {},
    avgSalary: 0,
    tableDataLoading: false,
    specialityList: [],
    specialityListLoading: false,
    specialityListError: false,
    form: {},
    specialityGroup: [],
    specialityGroupLoading: false,
    menuOpen: true
}
